import React from 'react';
import DashboardLayout from './DashboardLayout';
import AxesHeader from '../components/axes/AxesHeader';
import AxesRightPanel from '../components/axes/AxesRightPanel';
import AxesExplorer from '../pages/AxesExplorer';

const AxesLayout: React.FC = () => {
    return (
        <DashboardLayout>
            <div className="flex h-screen w-full bg-stone-950 text-zinc-100 overflow-hidden font-sans">

                {/* Center Content */}
                <div className="flex-1 flex flex-col min-w-0 bg-stone-950 relative z-0">
                    <AxesHeader />
                    <div className="flex-1 relative flex flex-col min-h-0 overflow-hidden">
                        <AxesExplorer />
                    </div>
                </div>

                {/* Right Panel */}
                <AxesRightPanel />
            </div>
        </DashboardLayout>
    );
};

export default AxesLayout;
